var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textStatus"},[(_vm.tableData.statusSty)?_c('div',{staticClass:"status",style:([_vm.statusSty])},[_c('ig-icon',{attrs:{"name":"yuan"}})],1):_vm._e(),_c('div',{staticClass:"content",style:([_vm.tableData.style, _vm.style]),on:{"click":_vm.webskip}},[_vm._v("\n\t\t"+_vm._s(_vm.content())+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }